// import React from "react";

// const ImageSection = () => {
//   return (
//     <div className="w-full">
//       <img
//         src="/images/slider1.png"
//         alt="Koltuk ve Kuru Temizleme Simgesi"
//         className="w-full h-50 max-w-md mx-auto"
//       />
//     </div>
//   );
// };

// export default ImageSection;
import React from "react";

const ImageSection = () => {
  return (
    <div className="w-full aspect-[2/1] max-w-4xl mx-auto">
      <img
        src="/images/slider1.png"
        alt="Koltuk ve Kuru Temizleme Simgesi"
        width={2880}
        height={1440}
        loading="lazy"
        className="w-full h-full object-cover"
      />
    </div>
  );
};

export default ImageSection;
